import { render, staticRenderFns } from "./DocumentDialog.vue?vue&type=template&id=c9ca54c0&"
import script from "./DocumentDialog.js?vue&type=script&lang=js&"
export * from "./DocumentDialog.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports